$(function () {
  'use strict';

  var $images = $('.js-object-fit');

  if(!$images.length) return;

  objectFitImages($images);
});
